/**
 * Display trigger configuration keys in chips
 */
import {toast} from '@wandb/common/components/elements/Toast';
import {Colors, hexToRGB} from '@wandb/common/css/globals.styles';
import copyToClipboard from 'copy-to-clipboard';
import React from 'react';
import styled from 'styled-components';

import {IconCopy} from '../../Icon';

const StyledConfigPill = styled.div`
  display: inline-flex;
  height: 24px;
  border-radius: 4px;
  padding: 4px 6px 4px 8px;
  align-items: center;
  background-color: ${hexToRGB(Colors.GRAY_500, 0.14)};
  color: ${Colors.GRAY_600};
`;
StyledConfigPill.displayName = 'S.StyledConfigPill';

const StyledConfigKey = styled.div`
  font-size: 13px;
  line-height: 16px;
  margin-right: 6px;
  font-family: 'Source Code Pro';
  font-weight: 400;
  letter-spacing: -0.05em;
`;
StyledConfigKey.displayName = 'S.StyledConfigKey';

const IconConfigKey = styled(IconCopy)`
  width: 13px;
  height: 13px;
  margin: 1.5px;
  cursor: pointer;
`;
IconConfigKey.displayName = 'S.IconConfigKey';

export const ConfigKey = ({configKey}: {configKey: string}) => {
  const copyConfigKey = React.useCallback((val: string) => {
    copyToClipboard(val);
    toast(`Copied '${val}' to clipboard`);
  }, []);
  return (
    <StyledConfigPill>
      <StyledConfigKey>{configKey}</StyledConfigKey>
      <IconConfigKey onClick={() => copyConfigKey(configKey)} />
    </StyledConfigPill>
  );
};
